import './FormStatement.css'
import VariableDropdown from '../../Variables/VariablesDropdown/VariablesDropdown';
import AreaList from '../UI/AreaList/AreaList';
import AreaListData from '../UI/AreaListData/AreaListData';
import AreaBlockStatement from './AreaBlockStatement/AreaBlockStatement';
import AreaBlockResponse from './AreaBlockResponse/AreaBlockResponses';
import TitleBlock from '../TitleBlock/TitleBlock';
import NiceModal from '@ebay/nice-modal-react';
import ResponseEdition from './ResponseEdition/ResponseEdition';
import StatementEdition from './StatementEdition/StatementEdition';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import { useTreeStateContext } from '../../../contexts/TreeContext';
import binarySearchString from '../../../utils/binarySearchString';
import { useTreeDispatchContext } from '../../../contexts/TreeContext';
import generateObjectId from '../../../utils/generateObjectId';
import BlockStatementTransformer from '../../../utils/transformers/BlockStatementTransformer';
import editorAction from '../../../actions/editorAction';
import { BlockStatementDefault } from '../../../data/constant/blocks/BlockStatementDefault';
import CheckBox from '/src/components/UI/CheckBox/CheckBox';
import TextInput from '/src/components/UI/TextField/TextInput';
import TextArea from '/src/components/UI/TextField/TextArea';

function FormStatement({ name, id }) {

    const { children, blocks } = useTreeStateContext();
    const indexBlock = binarySearchString(blocks, id, 'object_id');
    const data = blocks[indexBlock] ? blocks[indexBlock].data : BlockStatementDefault.data
    var childrenBlocks = children.filter(child => child.parent_block_id == id).sort((a, b) => a.index - b.index)
    const dispatch = useTreeDispatchContext();

    const { messages, responses } = data;

    var type = data.responses.length && data.responses[0].type == 'custom' ? 'custom' : 'quick'
    var variable_redirect = null;
    if (data.responses.length) {
        variable_redirect = data.variable_redirect ? data.variable_redirect : data.responses[0].variable
        if (variable_redirect) {
            variable_redirect.name = variable_redirect.name.toLowerCase();
        }
    }

    const { updateBlockData, createBlockChild, updateBlockChild, updateBlockChildren, deleteBlockChild } = editorAction();

    const [variableResponse, setVariableResponse] = useState(variable_redirect)
    //const [responseType, setResponseType] = useState(type)
    const [hasBackgroundText, setHasBackgroundText] = useState(data.has_background_text || false)
    const [backgroundText, setBackgroundText] = useState(data.background_content) || "";
    const [retries, setRetries] = useState(data.retries || "");
    const [hangupNoResponse, setHangupNoResponse] = useState(data.hangup_no_response || false)
    const [listeningDuringPromptDelay, setListeningDuringPromptDelay] = useState(data.listening_during_prompt_delay || false)
    const componentList = { messages: StatementEdition, responses: ResponseEdition }

    const { getValues, setValue } = useForm({
        mode: "onBlur",
        defaultValues: {
            messages,
            responses,
            variable_redirect,
            has_background_text: data.has_background_text != null ? data.has_background_text : false,
            background_content: data.background_content || "",
            retries: data.retries != null ? data.retries : 1,
            hangup_no_response: data.hangup_no_response != null ?data.hangup_no_response :  true,
            listening_during_prompt_delay: data.listening_during_prompt_delay != null ? data.listening_during_prompt_delay: 0
        }
    });

    const firstChild = childrenBlocks[0]
    const addRow = async (name, scroll) => {
        const isCustomResponse = getValues(name).filter(row => row.type == 'custom').length > 0
        const length = getValues(name).length
        const result = await NiceModal.show('editor-popup', { Component: componentList[name], componentProps: { isCustomResponse } });
        const { data } = result;


        if (name == 'responses') {
            addChild(data, length + 1);
            //createBlockChild()
        }

        const values = [...getValues(name)];
        values.splice(data.type == 'custom' ? 0 : length, 0, data)

        dispatch({ type: 'updateBlockData', payload: { id, data: { [name]: values } } })
        setValue(`${name}`, values)
        onSubmit(getValues());
        scroll()
    }

    // Permet d'ajouter une ligne en dessous du bloc, il ne faut pas l'utiliser pour les statements, juste les responses
    const addChild = async (data, index) => {
        const child = {
            text: data.content,
            object_id: generateObjectId(index),
            index: index,
            parent_block_id: firstChild.parent_block_id
        }

        var newChildrenBlocks = [...childrenBlocks]
        newChildrenBlocks.splice(data.type == 'custom' ? 1 : index, 0, child)
        newChildrenBlocks = newChildrenBlocks.map((child, idx) => { return { ...child, index: idx } })
        dispatch({ type: 'createBlockChild', payload: { block_id: id, data: child } })
        await createBlockChild(id, child)
        dispatch({ type: 'updateBlockChildren', payload: { block_id: id, children: newChildrenBlocks } })
        updateBlockChildren(id, newChildrenBlocks)
    }

    const setValueVariable = (name, value) => {
        setValue(name, value);
        onSubmit(getValues());
    }

    const handleBackgroundTextChange = (e) => {
        const checked = e.target.checked;
        setHasBackgroundText(checked);
        setValue('has_background_text', checked);
        onSubmit(getValues());
    }

    const handleHangupNoResponseChange = (e) => {
        const checked = e.target.checked;
        setHangupNoResponse(checked);
        setValue('hangup_no_response', checked);
        onSubmit(getValues());
    }

    const handleListeningDuringPromptDelayChange = (e) => {
        const checked = e.target.checked;
        setListeningDuringPromptDelay(checked);
        setValue('listening_during_prompt_delay', checked);
        onSubmit(getValues());
    }

    const setValueRow = (name, index, value) => {
        const length = getValues(name).length

        if (index == -1) {
            index = length - 1;
        }

        if (name == 'responses') {
            const object_id = childrenBlocks[index + 1].object_id;
            dispatch({ type: 'updateBlockChild', payload: { block_id: id, object_id, data: { text: value.content, is_not_link: value.is_not_link } } })
            updateBlockChild(id, object_id, { text: value.content })
        }
        setValue(`${name}.${index}`, value);
        dispatch({ type: 'updateBlockData', payload: { id, data: { [name]: [...getValues(name)] } } })
        onSubmit(getValues());
    }

    const deleteValueRow = (name, index) => {
        const length = getValues(name).length
        if (index == -1) {
            index = length - 1;
        }

        if (name == 'responses') {
            const object_id = childrenBlocks[index + 1].object_id;

            let newChildren = childrenBlocks
                .filter(childBlock => childBlock.index != (index + 1) && childBlock.index != 0)
                .map((childBlock, idx) => {
                    return { ...childBlock, index: (idx + 1).toString() }
                });


            dispatch({ type: 'deleteBlockChildAndOrderOther', payload: { block_id: id, object_id } })
            deleteBlockChild(id, object_id)
            updateBlockChildren(id, newChildren);
        }

        dispatch({ type: 'updateBlockData', payload: { id, data: { [name]: [...getValues(name).filter((message, idx) => idx !== index)] } } })

        setValue(name, getValues(name).filter((message, idx) => idx !== index));
        onSubmit(getValues());
    }

    const moveStatements = (index, step, object_id) => {
        move(index, step, messages, "messages");
    }

    const moveResponses = (index, step) => {
        move(index, step, responses, "responses");

        if (index + step < 0) {
            index = (responses.length - 1); // dernier element - 1 car on ne peux pas descendre mais obligatoirement monter
        }
        index += 1;
        [childrenBlocks[index], childrenBlocks[index + step]] = [childrenBlocks[index + step], childrenBlocks[index]]
        childrenBlocks[index].index = index;
        childrenBlocks[index + step].index = index + step;
        let childrenBlocksServer = [childrenBlocks[index], childrenBlocks[index + step]];
        dispatch({ type: 'updateBlockChildren', payload: { block_id: id, children: childrenBlocks } })

        updateBlockChildren(id, childrenBlocksServer);
    }

    const move = (index, step, array, propertyName) => {
        if (index + step < 0) {
            index = (array.length - 1); // dernier element - 1 car on ne peux pas descendre mais obligatoirement monter
        }

        [array[index], array[index + step]] = [array[index + step], array[index]]

        let res = Object.values({ ...getValues(propertyName), ...array });
        let payload = { id, data: {} }
        payload.data[propertyName] = res;


        dispatch({ type: 'updateBlockData', payload: payload })
        setValue(propertyName, res);
        onSubmit(getValues());
    }
    const functionMessages = {
        move: moveStatements,
        setValue: (index, value) => setValueRow('messages', index, value),
        deleteValue: (index) => deleteValueRow('messages', index),
    }

    const functionResponses = {
        move: moveResponses,
        setValue: (index, value) => setValueRow('responses', index, value),
        deleteValue: (index) => deleteValueRow('responses', index),
        isCustomResponseSet: () => getValues('responses').filter(row => row.type == 'custom').length > 0
    }

    const onSubmit = (data) => {
        const dataServer = BlockStatementTransformer(data);
        updateBlockData(id, data, dataServer)
    }
    return (
        <>
            <TitleBlock title="Statements" titleInput="Statement name" name={name} id={id} />
            <div className='area-edit'>
                <AreaList title="Sentences" buttonLabel="Add new Statement" maxHeight="230px" onClickButton={(arg) => addRow('messages', ...arg)}>
                    <AreaListData data={messages} ComponentRow={AreaBlockStatement} FunctionsRow={functionMessages}></AreaListData>
                </AreaList>
                <div className='grid-row' style={{ marginTop: '20px' }}>
                    <label className="dropdown_title">Save Response : </label>
                    <div className='dropdown_container'>
                        <VariableDropdown variable={variableResponse} setValue={setValueVariable} name="variable_redirect" />
                    </div>
                </div>
                <AreaList title="Responses" buttonLabel="Add new Response" maxHeight="200px" onClickButton={(arg) => addRow('responses', ...arg)}>
                    <AreaListData data={responses} childrenBlocks={childrenBlocks} ComponentRow={AreaBlockResponse} FunctionsRow={functionResponses}></AreaListData>
                </AreaList>
                <div className='grid-row' style={{ marginTop: '20px' }}>
                    <label className="dropdown_title">Has Background Text : </label>
                    <div className='dropdown_container' style={{ position: 'relative', bottom: '12px' }}>
                        <CheckBox name="has_background_text" checked={hasBackgroundText} onChange={handleBackgroundTextChange} />
                    </div>
                </div>
                {hasBackgroundText && (
                    <div>
                        <label className="dropdown_title">Background Content : </label><br></br>
                        <div className='dropdown_container'>
                            <TextArea name="background_content" value={backgroundText}
                                onChange={(e) => { setValue('background_content', e.target.value); setBackgroundText(e.target.value); }}
                                onBlur={() => onSubmit(getValues())} placeholder="Enter background content..." style={{ width: '93%' }}
                            />
                        </div>
                    </div>
                )}
                <div>
                    <label className="dropdown_title">Retries : </label><br></br>
                    <div className='dropdown_container'>
                        <TextInput type="number" name="retries" value={retries}
                            onChange={(e) => { setValue('retries', e.target.value); setRetries(e.target.value); }}
                            onBlur={() => onSubmit(getValues())} placeholder="Enter retries..." style={{ width: '93%' }}
                        />
                    </div>
                </div>
                <div className='grid-row' style={{ marginTop: '20px' }}>
                    <label className="dropdown_title">Hangup No Response : </label>
                    <div className='dropdown_container' style={{ position: 'relative', bottom: '12px' }}>
                        <CheckBox name="hangup_no_response" checked={hangupNoResponse} onChange={handleHangupNoResponseChange} />
                    </div>
                </div>
                <div className='grid-row' style={{ marginTop: '20px' }}>
                    <label className="dropdown_title">Listening Uhlive : </label>
                    <div className='dropdown_container' style={{ position: 'relative', bottom: '12px' }}>
                        <CheckBox name="listening_during_prompt_delay" checked={listeningDuringPromptDelay} onChange={handleListeningDuringPromptDelayChange} />
                        {/*
                        <TextInput type="number" name="listening_during_prompt_delay" value={listeningDuringPromptDelay}
                            onChange={(e) => { setValue('listening_during_prompt_delay', e.target.value); setListeningDuringPromptDelay(e.target.value); }}
                            onBlur={() => onSubmit(getValues())} placeholder="Enter delay..." style={{ width: '93%' }}
                        />
                        */}
                    </div>
                </div>
                <br></br><br></br>
            </div>
        </>
    )
}

export default FormStatement;